import React, { useEffect } from "react"
import Slick from "react-slick"
import classnames from "@utils/classnames"
import Frame from "@components/frame"
import Glow from "@components/glow"
import Button from "@components/button"
import BtmCloseBtn from "@components/btmCloseBtn"

import styles from "./slider.module.scss"

import arrowImg from "@images/arrow-next.png"

const Arrow = React.memo(({ prev = false, ...props }) => {
  return (
    <Button
      {...props}
      plain
      className={classnames(
        "slick-arrow",
        {
          "slick-prev": prev,
          "slick-next": !prev,
        },
        styles.arrow
      )}
    >
      <img src={arrowImg} />
    </Button>
  )
})

const Slider = React.forwardRef(
  (
    {
      data,
      renderItem,
      customDots,
      onClose,
      mobileCloseClassName,
      ...restProps
    },
    ref
  ) => {
    useEffect(() => {
      const event = e => {
        const t = e.target
        if (t.classList.contains("slick-slide")) {
          onClose()
        }
      }
      window.document.documentElement.addEventListener("click", event)
      return () => {
        window.document.documentElement.removeEventListener("click", event)
      }
    }, [onClose])

    const pageingProps =
      customDots && customDots.length > 0
        ? {
            dotsClass: styles.customDots,
            customPaging: i => {
              return (
                <Button>
                  <img src={customDots[i][0]} />
                  <img src={customDots[i][1]} />
                </Button>
              )
            },
          }
        : null
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <Arrow prev />,
      nextArrow: <Arrow />,
      ...restProps,
      ...pageingProps,
    }
    return (
      <div className={styles.container}>
        <Slick {...settings} ref={ref}>
          {data.map(item => {
            return (
              <Glow
                key={item.key}
                darker
                className={styles.frameContainer}
                glowClassName={styles.frameGlow}
              >
                <Frame key={item.key} className={styles.frame} type="dark">
                  {renderItem(item)}
                </Frame>
                <Button className={styles.closeBtn} onClick={onClose}>
                  CLOSE
                </Button>
              </Glow>
            )
          })}
        </Slick>
        <BtmCloseBtn
          className={classnames(styles.mobileCloseBtn, mobileCloseClassName)}
          onClick={onClose}
        />
      </div>
    )
  }
)

Slider.WholeWidthContainerInMobile = React.memo(props => {
  return (
    <div
      {...props}
      className={classnames(styles.wholeWidthInMobile, props.className)}
    />
  )
})

Slider.displayName = "Slider"
export default Slider
